module.exports = __webpack_public_path__ + "img/hero_portrait_monk_female.087fd4a4.png";